import React from 'react';
import { treatmentOption } from '../customsTreatments';
import './CustomsTags.css';

/* The border treatments a trader's goods might need, as small tags. Border
 * controls (port health, CITES, licence, excise, anti-dumping) stand out;
 * duty matters (high duty, quota, trade deal) stay quiet. `max` caps the
 * tags shown, with "+N" for the rest. A dash when we have no data. */
const CustomsTags = ({ keys, max = 3 }) => {
    if (!Array.isArray(keys)) {
        return <span className="customs-tags-none" title="No tariff data for the goods they trade">—</span>;
    }
    if (!keys.length) {
        return <span className="customs-tags-none" title="No special border treatments found for their goods">None found</span>;
    }
    const options = keys.map(treatmentOption).filter(Boolean);
    const shown = options.slice(0, max);
    const rest = options.slice(max);
    return (
        <span className="customs-tags" title={`Might need: ${options.map((o) => o.label).join(', ')}`}>
            {shown.map((o) => (
                <span key={o.key} className={`customs-tag${o.control ? ' control' : ''}`}>{o.label}</span>
            ))}
            {rest.length > 0 && <span className="customs-tag more">+{rest.length}</span>}
        </span>
    );
};

export default CustomsTags;
